import React, {useEffect, useState} from "react";
import { Input, Form, DatePicker, Divider, Col, Radio, Upload, message, Row, Select } from "antd";
import InboxOutlined from "@ant-design/icons/lib/icons/InboxOutlined";
import { VisaTypeExpKeys } from "constants/ConstantOptions";

function Page3({ formData, setFormData, form, onboardingFields }) {
    const { Dragger } = Upload;
    const {Option} = Select;
    const [isOtherSelected, setIsOtherSelected] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [fileListW2, setFileListW2] = useState(formData.w2_contract?formData.w2_contract.fileList:[]);
    const [fileListPassport, setFileListPassport] = useState(formData.us_passport_copy?formData.us_passport_copy.fileList:[]);
    const [fileListDLFront, setFileListDLFront] = useState(formData.driving_license_front?formData.driving_license_front.fileList:[]);
    const [fileListNaturalization, setFileListNaturalization] = useState(formData.naturalization_certificate?formData.naturalization_certificate.fileList:[]);
    const [fileListPassportCard, setFileListPassportCard] = useState(formData.us_passport_card?formData.us_passport_card.fileList:[]);
    const [fileListWorkPermit, setFileListWorkPermit] = useState(formData.work_permit?formData.work_permit.fileList:[]);
    const [fileListGC, setFileListGC] = useState(formData.gc_copy?formData.gc_copy.fileList:[]);
    const [fileListH4EAD, setFileListH4EAD] = useState(formData.h4_ead_copy?formData.h4_ead_copy.fileList:[]);
    const [fileListOPT, setFileListOPT] = useState(formData.opt_copy?formData.opt_copy.fileList:[]);
    const [fileListCPT, setFileListCPT] = useState(formData.cpt_copy?formData.cpt_copy.fileList:[]);
    const [fileListStateID, setFileListStateID] = useState(formData.state_id?formData.state_id.fileList:[]);
    const [fileListGCEAD, setFileListGCEAD] = useState(formData.gc_ead_copy?formData.gc_ead_copy.fileList:[]);
    const [fileListDLBack, setFileListDLBack] = useState(formData.driving_license_back?formData.driving_license_back.fileList:[]);

    const expiry_date_keys = Object.values(VisaTypeExpKeys)
    const acceptableFileTypes = ['jpg', 'jpeg', 'png', 'gif', 'pdf'];
    const getAcceptedFileTypesText = () => {
        return acceptableFileTypes.join(', ').toUpperCase();
    };
    const filterFilesByType = (fileList) => {
      return fileList.map(file => {
          const fileExtension = file.name.split('.').pop().toLowerCase();
          const isAcceptableFileType = acceptableFileTypes.includes(fileExtension);
  
          if (!isAcceptableFileType) {
              message.error(`Unsupported file type: ${file.name}`);
              return null;
          }
  
          return file;
      }).filter(Boolean); 
  };

    const selectedVisa = formData && formData.visa && formData.visa.replace(/ /g, '_')+"_copy"

    useEffect(()=>{
        if(formData && formData.gc_ead_copy && formData.gc_ead_copy.fileList){
            setFileList(formData.gc_ead_copy.fileList )
        }
        if(formData && formData.gc_copy && formData.gc_copy.fileList && formData.visa !== "GC EAD" ){
            setFileList(formData.gc_copy.fileList )
        }
        if(formData && formData.gc_copy && formData.gc_copy.fileList && formData.visa === "GC EAD" ){
            if (formData.gc_copy) delete formData.gc_copy;
            localStorage.setItem('formData', JSON.stringify({ ...formData }));
        }
        if(formData && formData.h4_ead_copy && formData.h4_ead_copy.fileList){
            setFileList(formData.h4_ead_copy.fileList )
        }
        if(formData && formData.opt_copy && formData.opt_copy.fileList){
            setFileList(formData.opt_copy.fileList )
        }
        if(formData && formData.cpt_copy && formData.cpt_copy.fileList){
            setFileList(formData.cpt_copy.fileList )
        }
        if(formData && formData.other_copy && formData.other_copy.fileList){
            setFileList(formData.other_copy.fileList )
        }
    },[])

    const handleFileChange = (info) => {
        let updatedFileList = [...info.fileList];

        updatedFileList = updatedFileList.filter((file) => {
            if (file.status === 'error') {
                message.error(`${file.name} file upload failed.`);
            }
            return file.status !== 'error';
        });
        updatedFileList = filterFilesByType(updatedFileList);
        setFileList(updatedFileList);
    };

    const handleDynamicFileChange = (info, name) => {
        let updatedFileList = [...info.fileList];
        updatedFileList = updatedFileList.filter((file) => {
            if (file.status === 'error') {
                message.error(`${file.name} file upload failed.`);
            }
            return file.status !== 'error';
        });
        updatedFileList = filterFilesByType(updatedFileList);

        switch(name) {
            case 'naturalization_certificate':
                setFileListNaturalization(updatedFileList);
                break;
            case 'us_passport_card':
                setFileListPassportCard(updatedFileList);
                break;
            case 'work_permit':
                setFileListWorkPermit(updatedFileList);
                break;
            case 'gc_copy':
                setFileListGC(updatedFileList);
                break;
            case 'h4_ead_copy':
                setFileListH4EAD(updatedFileList);
                break;
            case 'opt_copy':
                setFileListOPT(updatedFileList);
                break;
            case 'cpt_copy':
                setFileListCPT(updatedFileList);
                break;
            case 'state_id':
                setFileListStateID(updatedFileList);
                break;
            case 'driving_license_front':
                setFileListDLFront(updatedFileList);
                break;
            case 'us_passport_copy':
                setFileListPassport(updatedFileList);
                break;
            case 'w2_contract':
                setFileListW2(updatedFileList);
                break;
            case 'gc_ead_copy':
                setFileListGCEAD(updatedFileList);
                break;
            case 'driving_license_back':
                setFileListDLBack(updatedFileList);
                break;
            default:
                setFileList(updatedFileList);
        }

        if (formData) {
            const updatedFormData = { ...formData };
            updatedFormData[name] = { fileList: updatedFileList };
            setFormData(updatedFormData);
            localStorage.setItem('formData', JSON.stringify(updatedFormData));
        }
    };

    const handleBeforeUpload = (file) => {
        return false;
    };

    const handleRadioChange = (e) => {
        if (e.target.value === 'Other') {
            setIsOtherSelected(true);
        } else {
            setIsOtherSelected(false);
        }
        // if(e?.target?.value !== 'USC'){
        //     delete formData.us_passport_expiry;
        //     form.resetFields(['us_passport_expiry'])
        // }
        if (formData && (formData.gc_copy || formData.gc_ead_copy || formData.opt_copy || formData.h4_ead_copy || formData.cpt_copy || formData.other_copy)) {
            const { gc_ead_copy, opt_copy, h4_ead_copy, cpt_copy, other_copy, gc_copy } = formData;
            if (gc_copy) delete formData.gc_copy;
            if (gc_ead_copy) delete formData.gc_ead_copy;
            if (opt_copy) delete formData.opt_copy;
            if (h4_ead_copy) delete formData.h4_ead_copy;
            if (cpt_copy) delete formData.cpt_copy;
            if (other_copy) delete formData.other_copy;
            setFormData({ ...formData });
            form.resetFields(['gc_copy', 'gc_ead_copy', 'opt_copy', 'h4_ead_copy', 'cpt_copy', 'other_copy']);
            form.resetFields(expiry_date_keys);
            localStorage.setItem('formData', JSON.stringify({ ...formData }));
        }
    };

    const uploadProps = {
        multiple: false,
        fileList,
        beforeUpload: handleBeforeUpload,
        onChange: handleFileChange,
    };

    return (
        <div>
            <Form
                form={form}
                initialValues={formData}
                onValuesChange={(changedValues, allValues) => {
                    setFormData({ ...formData, ...allValues });
                }}
                className="gx-modal-box-form-item">
                {onboardingFields && onboardingFields.includes('legalities') && (
                    <>
                        <div style={{ width: '100%' }}>
                            <Divider />
                            <div style={{ width: "100%", textAlign: "center", fontWeight: "bold", fontSize: "15px" }}>Legalities</div>
                            <Divider />
                            <Row>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Input.Group>
                                        <Form.Item label='Visa at US entry' name="visa_at_us_entry"
                                            rules={[{
                                                required: true,
                                                message: 'Please enter Visa at US entry!'
                                            }]}
                                        >
                                            <Input type="text" autoComplete="off"/>
                                        </Form.Item>
                                    </Input.Group>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Input.Group>
                                        <Form.Item label='Visa source' name="current_visa_source"
                                            rules={[{
                                                required: true,
                                                message: 'Please enter Visa source!'
                                            }]}
                                        >
                                            <Input type="text" autoComplete="off"/>
                                        </Form.Item>
                                    </Input.Group>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Input.Group>
                                        <Form.Item label="Visa Status" name={'visa'} rules={[{
                                            required: true,
                                            message: 'Please enter Visa Status!'
                                        }]}>
                                            <Radio.Group
                                                options={["USC", "GC", "GC EAD", "H4 EAD", "OPT", "CPT", "Other"]}
                                                onChange={handleRadioChange}
                                            />
                                        </Form.Item>
                                        {isOtherSelected && (
                                            <Form.Item label="Please specify" name={'othervisa'} rules={[{
                                                required: true,
                                                message: 'Please enter Visa Status!'
                                            }]}>
                                                <Input placeholder="Enter your visa status" />
                                            </Form.Item>
                                        )}
                                    </Input.Group>
                                </Col>
                                {formData && formData.visa && formData.visa !== "USC" && (
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: '15px' }}>
                                        <Form.Item label={`Attach ${formData.visa} Copy`} name={selectedVisa.toLowerCase()}
                                            rules={[{
                                                required: true,
                                                message: 'Please upload document!'
                                            }]}
                                            help={<span><span style={{ color: 'red', fontSize: '10px' }}>({getAcceptedFileTypesText()})</span> </span>}>
                                            <Dragger {...uploadProps}
                                                fileList={formData[selectedVisa.toLowerCase()]?.fileList || []}
                                                onChange={(info) => handleDynamicFileChange(info, selectedVisa.toLowerCase())}>
                                                <p className="ant-upload-drag-icon">
                                                    <InboxOutlined />
                                                </p>
                                                <p className="ant-upload-text">Click or drag files to this area to upload</p>
                                            </Dragger>
                                        </Form.Item>
                                    </Col>
                                )}
                                {formData && formData.visa && !isOtherSelected && selectedVisa?.toLowerCase() && selectedVisa !== "USC_copy" && <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Form.Item label={`${formData?.visa} Valid Upto Date`} name={VisaTypeExpKeys?.[selectedVisa?.toLowerCase()]}
                                        rules={[{
                                            required: true,
                                            message: `${formData?.visa} is required!`
                                        }]}
                                    >
                                        <DatePicker
                                            format="MM/DD/YYYY"
                                            autoComplete="off"
                                            className="ant-input"
                                        />
                                    </Form.Item>
                                </Col>}
                            </Row>
                        </div>

                        <div style={{ width: '100%' }}>
                            <Divider />
                            <Row>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: '15px' }}>
                                    <Form.Item label="W2 Contract" name='w2_contract'
                                        help={<span><span style={{ color: 'red', fontSize: '10px' }}>({getAcceptedFileTypesText()})</span> </span>}>
                                        <Dragger {...uploadProps} fileList={fileListW2} onChange={(info) => handleDynamicFileChange(info, 'w2_contract')}>
                                            <p className="ant-upload-drag-icon">
                                                <InboxOutlined />
                                            </p>
                                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                        </Dragger>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: '15px' }}>
                                    <Form.Item label="Attach US Passport" name='us_passport_copy'
                                        rules={[{
                                            required: true,
                                            message: 'Please upload US Passport!'
                                        }]}
                                        help={<span><span style={{ color: 'red', fontSize: '10px' }}>({getAcceptedFileTypesText()})</span> </span>}>
                                        <Dragger {...uploadProps} fileList={fileListPassport} onChange={(info) => handleDynamicFileChange(info, 'us_passport_copy')}>
                                            <p className="ant-upload-drag-icon">
                                                <InboxOutlined />
                                            </p>
                                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                        </Dragger>
                                    </Form.Item>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} >
                                    <Form.Item label={`US Passport Expiry`} name={'us_passport_expiry'}
                                        rules={[{
                                            required: true,
                                            message: `US Passport Expiry is required!`
                                        }]}
                                    >
                                        <DatePicker
                                            format="MM/DD/YYYY"
                                            autoComplete="off"
                                            className="ant-input"
                                        />
                                    </Form.Item>
                                </Col>
                                </Col>
                            </Row>
                        </div>
                        <div style={{width: '100%' }}>
                            <Divider/>
                            <Row>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Form.Item label="Select Attachment Type" name={'attachment_type'}
                                        rules={[{
                                            required: true,
                                            message: 'Please select attachment type!'
                                        }]}>
                                        <Select>
                                            <Option key="state_id" value="state_id"> State Id </Option>
                                            <Option key="driving_license" value="driving_license">Driving License</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>

                                {form.getFieldValue('attachment_type') === "state_id" && (
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item label="Attach State ID" name='state_id' 
                                            rules={[{
                                                required: true,
                                                message: 'Please upload state Id!'
                                            }]}
                                            help={<span><span style={{ color: 'red', fontSize: '10px' }}>({getAcceptedFileTypesText()})</span> </span>}>
                                            <Dragger {...uploadProps} fileList={fileListStateID} onChange={(info) => handleDynamicFileChange(info, 'state_id')}>
                                                <p className="ant-upload-drag-icon">
                                                    <InboxOutlined />
                                                </p>
                                                <p className="ant-upload-text">Click or drag files to this area to upload</p>
                                            </Dragger>
                                        </Form.Item>
                                    </Col>
                                )}

                                {form.getFieldValue('attachment_type') === "driving_license" && (
                                    <>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item label="Driving License (Front)" name='driving_license_front' rules={[{
                                                required: true,
                                                message: 'Please upload DL front!'
                                            }]}
                                                help={<span><span style={{ color: 'red', fontSize: '10px' }}>({getAcceptedFileTypesText()})</span> </span>}>
                                                <Dragger {...uploadProps} fileList={fileListDLFront} onChange={(info) => handleDynamicFileChange(info, 'driving_license_front')}>
                                                    <p className="ant-upload-drag-icon">
                                                        <InboxOutlined />
                                                    </p>
                                                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                                </Dragger>
                                            </Form.Item>
                                        </Col>
                                    </>
                                )}
                                {form.getFieldValue('attachment_type') && ['driving_license']?.includes(form.getFieldValue('attachment_type')) && 
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                    <Form.Item label={`Driving License Valid Upto Date`} name={'driving_license_expiry'}
                                        rules={[{
                                            required: true,
                                            message: `DL Valid Upto Date is required!`
                                        }]}
                                    >
                                        <DatePicker
                                            format="MM/DD/YYYY"
                                            autoComplete="off"
                                            className="ant-input"
                                        />
                                    </Form.Item>
                                </Col>}
                           </Row>
                        </div>
                    </>
                )}
            </Form>
        </div>
    );
}

export default Page3;
